/* Strolee Freedom: global behavior. Written without optional chaining so older Safari still parses it. */
(function () {
  'use strict';

  var theme = window.theme || {};
  var doc = document;
  var html = doc.documentElement;

  /* ---------- helpers ---------- */
  function qs(sel, root) { return (root || doc).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var format = theme.moneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var noDecimals = Math.round(cents / 100).toString();
    var withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var trimmed = withCommas.replace(/\.00$/, '');
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      if (key === 'amount_no_decimals') return noDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return trimmed;
    });
  }

  var toastTimer;
  /* announce(message): shows a short toast that screen readers also read.
     announce(message, true): spoken only, for changes the page already shows. */
  function announce(message, quiet) {
    if (quiet) {
      var region = qs('#LiveQuiet');
      if (region && message) { region.textContent = ''; setTimeout(function () { region.textContent = message; }, 30); }
      return;
    }
    var toast = qs('#LiveToast');
    if (!toast || !message) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 4000);
  }

  function focusable(root) {
    return qsa('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])', root)
      .filter(function (el) { return el.offsetParent !== null || el === doc.activeElement; });
  }

  /* ---------- drawers ---------- */
  var openDrawer = null;
  var lastTrigger = null;

  function drawerOpen(id, trigger) {
    var el = doc.getElementById(id);
    if (!el) return;
    if (openDrawer && openDrawer !== el) drawerClose();
    lastTrigger = trigger || doc.activeElement;
    el.removeAttribute('inert');
    el.classList.add('is-open');
    html.style.overflow = 'hidden';
    openDrawer = el;
    qsa('[data-drawer-open="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var first = qs('[data-drawer-close]:not(.drawer__scrim)', el) || focusable(el)[0];
    if (first) setTimeout(function () { first.focus(); }, 60);
  }

  function drawerClose() {
    if (!openDrawer) return;
    var el = openDrawer;
    el.classList.remove('is-open');
    el.setAttribute('inert', '');
    html.style.overflow = '';
    qsa('[data-drawer-open="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    openDrawer = null;
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }

  doc.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      event.preventDefault();
      drawerOpen(opener.getAttribute('data-drawer-open'), opener);
      return;
    }
    if (event.target.closest('[data-drawer-close]')) {
      event.preventDefault();
      drawerClose();
    }
  });

  doc.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      if (openDrawer) { drawerClose(); return; }
      qsa('[data-nav-dd][open]').forEach(function (d) {
        d.removeAttribute('open');
        var s = qs('summary', d);
        if (s) s.focus();
      });
    }
    if (event.key === 'Tab' && openDrawer) {
      var items = focusable(openDrawer);
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && doc.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && doc.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });

  /* ---------- header dropdowns: one open at a time, close on outside click ---------- */
  doc.addEventListener('toggle', function (event) {
    var d = event.target;
    if (!d.matches || !d.matches('[data-nav-dd]') || !d.open) return;
    qsa('[data-nav-dd][open]').forEach(function (other) { if (other !== d) other.removeAttribute('open'); });
    var input = qs('input[type="search"]', d);
    if (input) setTimeout(function () { input.focus(); }, 30);
  }, true);

  doc.addEventListener('click', function (event) {
    if (event.target.closest('[data-nav-dd]')) return;
    qsa('[data-nav-dd][open]').forEach(function (d) { d.removeAttribute('open'); });
  });

  function measureHeader() {
    var header = qs('[data-header]');
    if (header) html.style.setProperty('--header-h', header.offsetHeight + 'px');
  }
  measureHeader();
  window.addEventListener('resize', measureHeader);

  /* ---------- cart ---------- */
  var Cart = {
    sectionIds: function () {
      var ids = [];
      if (qs('#CartDrawer')) ids.push('cart-drawer');
      var page = qs('[data-cart-page]');
      if (page) ids.push(page.getAttribute('data-section-id'));
      return ids;
    },

    request: function (url, body) {
      body.sections = this.sectionIds().join(',');
      body.sections_url = window.location.pathname;
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || data.status) {
            var err = new Error(data.description || data.message || theme.strings.cartError);
            err.data = data;
            throw err;
          }
          return data;
        });
      });
    },

    add: function (items) {
      var self = this;
      return this.request(theme.routes.cartAdd, { items: items }).then(function (data) {
        self.render(data.sections);
        return self.refreshCount();
      });
    },

    change: function (key, quantity) {
      var self = this;
      return this.request(theme.routes.cartChange, { id: key, quantity: quantity }).then(function (data) {
        self.render(data.sections);
        self.setCount(data.item_count);
        return data;
      });
    },

    update: function (payload) {
      return fetch(theme.routes.cartUpdate, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (res) { return res.json(); });
    },

    render: function (sections) {
      if (!sections) return;
      Object.keys(sections).forEach(function (id) {
        if (!sections[id]) return;
        var parsed = new DOMParser().parseFromString(sections[id], 'text/html');
        var selector = id === 'cart-drawer' ? '[data-cart-drawer-inner]' : '[data-cart-page]';
        var fresh = qs(selector, parsed);
        var current = qs(selector);
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      });
    },

    refreshCount: function () {
      var self = this;
      return fetch(theme.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) { self.setCount(cart.item_count); return cart; });
    },

    setCount: function (count) {
      qsa('[data-cart-count]').forEach(function (el) { el.textContent = count > 0 ? count : ''; });
      qsa('[data-cart-label]').forEach(function (el) {
        el.setAttribute('aria-label', (theme.strings.cartLabel || 'Cart, {count} items').replace('{count}', count));
      });
      doc.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: count } }));
    },

    open: function (trigger) {
      if (theme.cartType === 'page' || !qs('#CartDrawer')) { window.location.href = theme.routes.cart; return; }
      drawerOpen('CartDrawer', trigger);
    }
  };

  doc.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-cart-toggle]');
    if (toggle && theme.cartType === 'drawer' && qs('#CartDrawer') && !qs('[data-cart-page]')) {
      event.preventDefault();
      Cart.open(toggle);
      return;
    }

    var step = event.target.closest('[data-qty-step]');
    if (step) {
      var wrap = step.closest('.qty');
      var input = qs('input', wrap);
      var next = Math.max(parseInt(input.min || '0', 10), (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-qty-step'), 10));
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    var remove = event.target.closest('[data-line-remove]');
    if (remove) {
      event.preventDefault();
      lineChange(remove.getAttribute('data-line-remove'), 0, remove);
      return;
    }

    var addon = event.target.closest('[data-cart-addon]');
    if (addon) {
      event.preventDefault();
      addon.setAttribute('aria-busy', 'true');
      var item = { id: parseInt(addon.getAttribute('data-cart-addon'), 10), quantity: 1 };
      var ship = addon.getAttribute('data-ship');
      if (ship) { item.properties = {}; item.properties[theme.strings.shipProperty] = ship; }
      Cart.add([item]).then(function () {
        announce(theme.strings.added);
      }).catch(function (err) {
        addon.removeAttribute('aria-busy');
        announce(err.message);
      });
    }
  });

  function lineChange(key, quantity, origin) {
    var line = origin.closest('[data-line]');
    if (line) line.style.opacity = '0.5';
    Cart.change(key, quantity).then(function () {
      announce(quantity === 0 ? theme.strings.removed : theme.strings.updated);
      var heading = qs('[data-cart-drawer-inner] [data-drawer-close]:not(.drawer__scrim)');
      if (openDrawer && heading && !openDrawer.contains(doc.activeElement)) heading.focus();
    }).catch(function (err) {
      if (line) line.style.opacity = '';
      var box = qs('[data-cart-error]');
      if (box) { box.textContent = err.message; box.hidden = false; }
      announce(err.message);
    });
  }

  doc.addEventListener('change', function (event) {
    /* Quiz result card: the color picker drives the Add to cart button beside it. */
    var pickColor = event.target.closest('[data-finder-variant]');
    if (pickColor) {
      var buy = pickColor.closest('[data-finder-buy]');
      var btn = buy && qs('[data-cart-addon]', buy);
      var opt = pickColor.options[pickColor.selectedIndex];
      if (btn && opt) {
        btn.setAttribute('data-cart-addon', opt.value);
        if (opt.getAttribute('data-ship')) btn.setAttribute('data-ship', opt.getAttribute('data-ship')); else btn.removeAttribute('data-ship');
        var label = qs('.btn__label', btn);
        var tpl = btn.getAttribute('data-label') || '';
        if (label && tpl) { var hidden = qs('.visually-hidden', label); label.textContent = tpl.replace('[price]', opt.getAttribute('data-price') || ''); if (hidden) label.appendChild(hidden); }
      }
      return;
    }
    var qty = event.target.closest('[data-line-qty]');
    if (qty) {
      lineChange(qty.getAttribute('data-line-qty'), Math.max(0, parseInt(qty.value, 10) || 0), qty);
      return;
    }
    var note = event.target.closest('[data-cart-note]');
    if (note) {
      Cart.update({ note: note.value });
      return;
    }
    var attr = event.target.closest('[data-cart-attribute]');
    if (attr) {
      var attributes = {};
      attributes[attr.getAttribute('data-cart-attribute')] = attr.type === 'checkbox' ? (attr.checked ? 'Yes' : '') : attr.value;
      Cart.update({ attributes: attributes });
      var reveal = attr.getAttribute('data-reveals');
      if (reveal) { var target = doc.getElementById(reveal); if (target) target.hidden = !attr.checked; }
    }
  });

  /* ---------- email capture (Klaviyo client API with graceful fallback to the Shopify form) ---------- */
  function klaviyoSubscribe(options) {
    var k = theme.klaviyo || {};
    var profile = { email: options.email };
    if (options.phone) profile.phone_number = options.phone;
    if (options.properties) profile.properties = options.properties;
    profile.subscriptions = { email: { marketing: { consent: 'SUBSCRIBED' } } };
    if (options.phone) profile.subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };
    var body = {
      data: {
        type: 'subscription',
        attributes: { custom_source: options.source || 'Website form', profile: { data: { type: 'profile', attributes: profile } } },
        relationships: { list: { data: { type: 'list', id: options.list || k.list } } }
      }
    };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(k.key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': k.revision || '2026-07-15' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error('Subscription failed');
      return true;
    });
  }

  function klaviyoBackInStock(email, variantId) {
    var k = theme.klaviyo || {};
    var body = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email: email } } } },
        relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } } }
      }
    };
    return fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(k.key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': k.revision || '2026-07-15' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error('Request failed');
      return true;
    });
  }

  function validEmail(value) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value); }

  function showMessage(box, type, text) {
    if (!box) return;
    box.innerHTML = '';
    var p = doc.createElement('p');
    p.className = 'form-message form-message--' + type;
    p.textContent = text;
    box.appendChild(p);
  }

  if (window.customElements && !customElements.get('email-capture')) {
    customElements.define('email-capture', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        var form = qs('form', this);
        if (!form) return;
        form.addEventListener('submit', function (event) {
          var input = qs('input[type="email"]', form);
          var box = qs('[data-message]', form);
          var email = (input.value || '').trim();
          if (!validEmail(email)) {
            event.preventDefault();
            input.setAttribute('aria-invalid', 'true');
            showMessage(box, 'error', theme.strings.emailInvalid);
            input.focus();
            return;
          }
          input.removeAttribute('aria-invalid');
          var k = theme.klaviyo || {};
          if (!k.key || !k.list) return;
          event.preventDefault();
          var button = qs('button[type="submit"]', form);
          button.setAttribute('aria-busy', 'true');
          klaviyoSubscribe({ email: email, source: self.getAttribute('data-source') }).then(function () {
            button.removeAttribute('aria-busy');
            form.reset();
            showMessage(box, 'success', theme.strings.emailSuccess);
          }).catch(function () {
            form.submit();
          });
        });
      }
    });
  }

  /* ---------- click-to-load video ---------- */
  doc.addEventListener('click', function (event) {
    var play = event.target.closest('[data-video-play]');
    if (!play) return;
    var wrap = play.closest('.lite-video');
    var tpl = qs('template', wrap);
    if (!tpl) return;
    event.preventDefault();
    wrap.appendChild(tpl.content.cloneNode(true));
    var poster = qs('img', wrap);
    if (poster) poster.setAttribute('hidden', '');
    play.setAttribute('hidden', '');
    var video = qs('video', wrap);
    if (video) { video.focus(); var p = video.play(); if (p && p.catch) p.catch(function () {}); }
  });

  window.Strolee = {
    Cart: Cart,
    announce: announce,
    formatMoney: formatMoney,
    drawerOpen: drawerOpen,
    drawerClose: drawerClose,
    klaviyoSubscribe: klaviyoSubscribe,
    klaviyoBackInStock: klaviyoBackInStock,
    validEmail: validEmail,
    showMessage: showMessage,
    qs: qs,
    qsa: qsa
  };
})();

/* Auto-submit controls (sorting). Without JavaScript a visible Apply button does the same job. */
document.addEventListener('change', function (event) {
  var control = event.target.closest ? event.target.closest('[data-auto-submit]') : null;
  if (!control) return;
  var form = control.form;
  if (form) { if (form.requestSubmit) form.requestSubmit(); else form.submit(); }
});

/* ---------- Motion ----------
   Small, cheap movement: sections and cards rise in as they enter the view, photos marked data-parallax
   drift a little slower than the page, numbers marked data-count count up once. Everything is transforms
   and opacity only, runs through requestAnimationFrame, and switches off for people who prefer reduced motion. */
(function () {
  var html = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mode = html.getAttribute('data-motion') || 'respect';
  if (mode === 'off' || (mode !== 'always' && reduce)) { html.classList.add('no-motion'); return; }
  html.classList.add('motion');

  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* Reveal: the items inside a group get a stagger index; the group is observed once. */
  function setupReveal() {
    var targets = qsa('[data-reveal], [data-reveal-group]');
    qsa('[data-reveal-group]').forEach(function (group) {
      qsa(':scope > *', group).forEach(function (child, i) { child.style.setProperty('--i', String(Math.min(i, 8))); });
    });
    if (!('IntersectionObserver' in window)) { targets.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    targets.forEach(function (el) {
      if (el.classList.contains('is-in')) return;
      if (el.getBoundingClientRect().top < window.innerHeight * 0.9) { el.classList.add('is-in'); return; }
      io.observe(el);
    });
  }

  /* Parallax: a photo inside an overflow-hidden box moves by a fraction of its distance from the viewport center. */
  var items = [];
  var ticking = false;
  function measure() {
    items = qsa('[data-parallax], .is-parallax').map(function (el) {
      var speed = parseFloat(el.getAttribute('data-parallax')) || parseFloat(window.getComputedStyle(el).getPropertyValue('--parallax')) || 0.12;
      return { el: el, speed: speed, box: el.parentElement };
    });
  }
  function frame() {
    ticking = false;
    var vh = window.innerHeight;
    items.forEach(function (item) {
      var r = item.box.getBoundingClientRect();
      if (r.bottom < -vh || r.top > vh * 2) return;
      var center = r.top + r.height / 2 - vh / 2;
      /* The photo is scaled by 1.14, so it can move 7% of the box height each way before an edge shows. */
      var limit = Math.min(80, r.height * 0.07);
      var y = Math.max(-limit, Math.min(limit, -center * item.speed));
      item.el.style.transform = 'translate3d(0, ' + y.toFixed(1) + 'px, 0) scale(1.14)';
    });
  }
  function request() { if (!ticking) { ticking = true; window.requestAnimationFrame(frame); } }

  /* Count-up: numbers written as text, with the digits animated once the element is in view. */
  function setupCounts() {
    var els = qsa('[data-count]');
    if (!els.length) return;
    var run = function (el) {
      var raw = el.getAttribute('data-count') || el.textContent;
      var match = String(raw).match(/^([^0-9]*)([0-9][0-9,.]*)(.*)$/);
      if (!match) return;
      var prefix = match[1], suffix = match[3];
      var numeric = parseFloat(match[2].replace(/,/g, ''));
      var decimals = (match[2].split('.')[1] || '').length;
      var start = null; var duration = 1100;
      var step = function (ts) {
        if (!start) start = ts;
        var t = Math.min(1, (ts - start) / duration);
        var eased = 1 - Math.pow(1 - t, 3);
        var value = (numeric * eased).toFixed(decimals);
        if (!decimals) value = Number(value).toLocaleString('en-US');
        el.textContent = prefix + value + suffix;
        if (t < 1) window.requestAnimationFrame(step);
      };
      window.requestAnimationFrame(step);
    };
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.isIntersecting) { run(entry.target); io.unobserve(entry.target); } });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Hero video that plays on its own: only once the page's movement is on, muted, and only when it is in view. */
  function setupHeroVideo() {
    qsa('.hero__video').forEach(function (video) {
      video.muted = true;
      var tryPlay = function () {
        var p = video.play();
        if (p && p.then) p.then(function () { video.classList.add('is-playing'); }).catch(function () {});
        else video.classList.add('is-playing');
      };
      video.addEventListener('playing', function () { video.classList.add('is-playing'); });
      if (!('IntersectionObserver' in window)) { tryPlay(); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { if (entry.isIntersecting) tryPlay(); else if (!video.paused) video.pause(); });
      }, { threshold: 0.2 });
      io.observe(video);
    });
  }

  function init() {
    setupReveal();
    setupCounts();
    setupHeroVideo();
    measure();
    frame();
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', function () { measure(); request(); });
    document.addEventListener('shopify:section:load', function () { setupReveal(); setupHeroVideo(); measure(); request(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Footer columns fold on phones and stay open on wider screens. */
(function () {
  var mq = window.matchMedia ? window.matchMedia('(max-width: 699px)') : null;
  if (!mq) return;
  function apply() {
    Array.prototype.forEach.call(document.querySelectorAll('details.footer-col'), function (d) { d.open = !mq.matches; });
  }
  apply();
  if (mq.addEventListener) mq.addEventListener('change', apply); else if (mq.addListener) mq.addListener(apply);
})();

/* Special offer countdown, independent of the movement setting. */
(function () {
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  /* Offer countdown on offer pages. A fixed end (data-until, New York time) counts down to the same moment for
     everyone and then shows the ended text. Hours (data-hours) start when a visitor first lands on the page,
     are remembered in their browser, and start over once they run out. */
  function setupOfferTimers() {
    qsa('[data-offer-timer]').forEach(function (el) {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      var hours = parseFloat(el.getAttribute('data-hours')) || 0;
      var until = (el.getAttribute('data-until') || '').trim();
      var key = el.getAttribute('data-key') || 'offer';
      var fixed = null;
      if (until) {
        var m = until.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/);
        if (m) {
          /* New York offset: EDT (UTC-4) from the second Sunday of March to the first Sunday of November, else EST (UTC-5). */
          var y = +m[1], mo = +m[2] - 1, d = +m[3], h = m[4] ? +m[4] : 0, mi = m[5] ? +m[5] : 0;
          var nthSunday = function (year, month, n) { var first = new Date(Date.UTC(year, month, 1)).getUTCDay(); return 1 + ((7 - first) % 7) + (n - 1) * 7; };
          var dstStart = Date.UTC(y, 2, nthSunday(y, 2, 2), 7);
          var dstEnd = Date.UTC(y, 10, nthSunday(y, 10, 1), 6);
          var guess = Date.UTC(y, mo, d, h, mi);
          var offset = guess >= dstStart && guess < dstEnd ? 4 : 5;
          fixed = Date.UTC(y, mo, d, h + offset, mi);
        }
      }
      var end;
      var store = function (value) { try { localStorage.setItem(key, String(value)); } catch (e) {} };
      var read = function () { try { return parseInt(localStorage.getItem(key), 10) || 0; } catch (e) { return 0; } };
      var reset = function () { end = Date.now() + hours * 3600000; store(end); };
      if (fixed) end = fixed;
      else if (hours > 0) { end = read(); if (!end || end - Date.now() > hours * 3600000) reset(); }
      else return;
      var out = { h: qs('[data-timer-h]', el), m: qs('[data-timer-m]', el), s: qs('[data-timer-s]', el) };
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var tick = function () {
        var left = end - Date.now();
        if (left <= 0) {
          if (fixed) { el.textContent = el.getAttribute('data-ended') || ''; el.classList.add('offer__timer--ended'); return; }
          reset(); left = end - Date.now();
        }
        var total = Math.floor(left / 1000);
        if (out.h) out.h.textContent = pad(Math.floor(total / 3600));
        if (out.m) out.m.textContent = pad(Math.floor((total % 3600) / 60));
        if (out.s) out.s.textContent = pad(total % 60);
        el.hidden = false;
        setTimeout(tick, 1000);
      };
      tick();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupOfferTimers); else setupOfferTimers();
  document.addEventListener('shopify:section:load', setupOfferTimers);
})();

/* Review topic chips: ask Stamped's main widget for the reviews that mention a keyword. The review text itself
   is Stamped's and is never changed here; "All" clears the keyword. */
(function () {
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function reload(widget) {
    var fn = window.StampedFn;
    if (fn && typeof fn.loadWidget === 'function') { try { fn.loadWidget(true); return true; } catch (e) {} }
    return false;
  }
  function setupReviewChips() {
    qsa('[data-review-chips]').forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      var widget = document.getElementById(box.getAttribute('data-target') || 'stamped-main-widget');
      if (!widget) { box.hidden = true; return; }
      var status = box.querySelector('[data-review-chips-status]');
      var chips = qsa('[data-review-chip]', box);
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var word = chip.getAttribute('data-search') || '';
          chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
          if (word) widget.setAttribute('data-search', word); else widget.removeAttribute('data-search');
          var ok = reload(widget);
          if (status) status.textContent = word ? 'Showing reviews that mention ' + chip.textContent.trim() + '.' : 'Showing all reviews.';
          if (ok) { var top = widget.getBoundingClientRect().top + window.pageYOffset - 120; if (top < window.pageYOffset) window.scrollTo({ top: top, behavior: 'smooth' }); }
        });
      });
    });
  }
  /* Product chips (Reviews page): point the widget at another product, clear the keyword, reload. */
  function setupProductChips() {
    qsa('[data-review-products]').forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      var widget = document.getElementById(box.getAttribute('data-target') || 'stamped-main-widget');
      if (!widget) { box.hidden = true; return; }
      var status = box.querySelector('[data-review-products-status]');
      var chips = qsa('[data-review-product]', box);
      var heading = document.querySelector('[data-review-product-heading]');
      var keys = ['product-id', 'product-sku', 'name', 'url', 'image-url', 'product-type', 'description'];
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          if (chip.getAttribute('aria-pressed') === 'true') return;
          chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
          keys.forEach(function (k) { var v = chip.getAttribute('data-' + k); if (v !== null) widget.setAttribute('data-' + k, v); });
          widget.removeAttribute('data-search');
          qsa('[data-review-chip]').forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-search') ? 'false' : 'true'); });
          var title = chip.getAttribute('data-title') || chip.textContent.trim();
          if (heading) heading.textContent = (heading.getAttribute('data-template') || '[product] reviews').replace('[product]', title);
          reload(widget);
          if (status) status.textContent = 'Showing reviews for ' + title + '.';
        });
      });
    });
  }
  /* Review photos: Stamped loads 180 px thumbnails; swap in 600 px versions so the bigger photos stay sharp. */
  function sharpenPhotos(root) {
    qsa('.stamped-review-image img, .stamped-photo img', root || document).forEach(function (img) {
      ['src', 'data-src'].forEach(function (attr) {
        var v = img.getAttribute(attr);
        if (v && v.indexOf('/tr:h-180:') > -1) img.setAttribute(attr, v.replace('/tr:h-180:', '/tr:h-600:'));
      });
    });
  }
  function watchPhotos() {
    if (!('MutationObserver' in window) || !document.getElementById('stamped-main-widget')) return;
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; sharpenPhotos(); }, 150);
    }).observe(document.body, { childList: true, subtree: true });
    sharpenPhotos();
  }
  function init() { setupReviewChips(); setupProductChips(); watchPhotos(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { setupReviewChips(); setupProductChips(); });
})();

/* "Made for every kind of day" row: dots on phones, arrows on wide screens. Scrolling is native. */
(function () {
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function setupRows() {
    qsa('[data-prow]').forEach(function (row) {
      if (row.dataset.ready) return;
      row.dataset.ready = '1';
      var track = row.querySelector('[data-prow-track]');
      var items = qsa('[data-prow-item]', track);
      var dotsBox = row.querySelector('[data-prow-dots]');
      var section = row.closest('.section') || row;
      var nav = section.querySelector('[data-prow-nav]');
      var prev = nav ? nav.querySelector('[data-prow-prev]') : null;
      var next = nav ? nav.querySelector('[data-prow-next]') : null;
      if (!track || items.length < 2) { if (nav) nav.hidden = true; return; }
      var goTo = window.theme && window.theme.strings && window.theme.strings.carouselGoTo || 'Go to tile [number]';
      var dots = items.map(function (item, i) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'prow__dot';
        b.setAttribute('aria-label', goTo.replace('[number]', String(i + 1)));
        b.addEventListener('click', function () { track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' }); });
        if (dotsBox) dotsBox.appendChild(b);
        return b;
      });
      function current() {
        var x = track.scrollLeft, best = 0, dist = Infinity;
        items.forEach(function (item, i) { var d = Math.abs(item.offsetLeft - track.offsetLeft - x); if (d < dist) { dist = d; best = i; } });
        return best;
      }
      function update() {
        var i = current();
        dots.forEach(function (d, j) { if (j === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
        var overflow = track.scrollWidth > track.clientWidth + 4;
        if (nav) nav.hidden = !overflow;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
      function step(dir) {
        var i = current() + dir;
        i = Math.max(0, Math.min(items.length - 1, i));
        track.scrollTo({ left: items[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      var raf = null;
      track.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = null; update(); }); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupRows); else setupRows();
  document.addEventListener('shopify:section:load', setupRows);
})();
